import { themeProps } from '../../styles/theme';

export const getPillColor = (count: number, total: number) => {
  let color = themeProps.colors.cobalt;
  const pct = (count / total) * 100;
  if (pct > 25 && pct < 70) color = themeProps.colors.alertYellow;
  else if (pct > 70) color = themeProps.colors.warningRed;
  return color;
};

export const knownOfflineTag = 'known-offline';
